import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiInstance } from "./axiosApi";
import authHeader from "./authHeader";

export const getQuestionData = createAsyncThunk(
  "topic/question",
  async (
    { page, limit, classesFilter, subjectFilter, search },
    { rejectWithValue }
  ) => {
    try {
      let url = `/question/all?page=${page}&limit=${limit}`;

      if (classesFilter) {
        url += `&classesFilter=${classesFilter}`;
      }
      if (subjectFilter) {
        url += `&subjectFilter=${subjectFilter}`;
      }
      if (search) {
        url += `&search=${search}`;
      }
      const response = await apiInstance.get(url, { headers: authHeader() });
      return response;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
export const copyQuestions = createAsyncThunk(
  "copy/question",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(
        `/question/copy-question-classes`,
        payload,
        { headers: authHeader() }
      );
      return response;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

const initialState = {
  questionData: [],
  getQuestionData: [],
};

const questionSlice = createSlice({
  name: "questionSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getQuestionData.fulfilled, (state, action) => {
      state.questionData = action.payload.data;
    });
  },
});
export default questionSlice.reducer;
